

import React from "react";
import Col from "../Col";
import Row from "../Row";
import { useSelector } from "react-redux";
import moment from 'moment';
import TextEditor from "../Editor/Editor";
import InboxAnnouncementView from "./InboxAnnouncementView";
import './Inbox.scss';

const InboxPropertyAnnouncementsList = ({
    onSetAnnouncement,
    announcement
}) => {
    const announcmentsListByProperty = useSelector(state => state.inbox?.announcmentsListByProperty || [])
    
    return (
        announcement && announcement.id ? 
        <InboxAnnouncementView 
          announcement={announcement}
          onSetAnnouncement={onSetAnnouncement}
        />
        :
        <div className='announcementListScroll'>
        {announcmentsListByProperty && announcmentsListByProperty.length > 0 &&
        announcmentsListByProperty.map((amt, i) => {
            return (
                <>
                <Row key={i}>
                  <Col md={12} xs={12}>
                    <div class="dateDesign">
                      <div class="or or--x" aria-role="presentation">{amt.date}</div>
                    </div>
                  </Col>
                </Row>
                {amt.announcements.map((annoucement, i) => {
                  return (
             <div className='announcementArea' style={{cursor: 'pointer', }} onClick={() => onSetAnnouncement(annoucement)}>  
                <div id="messagesAreaBg" className='announcementPadding'>      
                    <div className='announcementHead'>
                      <h2><img src='/assets/annoucement.png'/>{annoucement.title}
                       <span>{moment(annoucement.announcementDate).format('LT')}</span>
                       </h2> 
                    </div>
                    <TextEditor 
                        editorState={annoucement.description}
                        readOnly={true}
                    />
                  </div>
                  </div>
                  )})}
                </>
            )
        })
      }
      </div>
    )
}

export default InboxPropertyAnnouncementsList;